import { PaginationAction } from '@common/ts/enums';
import { DataTablePaginationProps } from '@/types';

export const usePaginationHandlers = ({
  table,
  currentPage,
  onPageChange,
}: DataTablePaginationProps) => {
  // Generic handler that works for both URL-based and table-based pagination
  const createPaginationPageHandler = (pageAction: PaginationAction) => {
    return () => {
      if (onPageChange && currentPage) {
        // URL-based pagination
        const pageActions = {
          [PaginationAction.FIRST]: () => onPageChange(1),
          [PaginationAction.PREVIOUS]: () => onPageChange(currentPage - 1),
          [PaginationAction.NEXT]: () => onPageChange(currentPage + 1),
          [PaginationAction.LAST]: () => onPageChange(table.getPageCount()),
        };
        pageActions[pageAction]();
      } else {
        // Table-based pagination
        const pageActions = {
          [PaginationAction.FIRST]: () => table.setPageIndex(0),
          [PaginationAction.PREVIOUS]: () => table.previousPage(),
          [PaginationAction.NEXT]: () => table.nextPage(),
          [PaginationAction.LAST]: () => table.setPageIndex(table.getPageCount() - 1),
        };
        pageActions[pageAction]();
      }
    };
  };

  // Create all handlers using the generic function
  const handlers = {
    handleFirstPage: createPaginationPageHandler(PaginationAction.FIRST),
    handlePreviousPage: createPaginationPageHandler(PaginationAction.PREVIOUS),
    handleNextPage: createPaginationPageHandler(PaginationAction.NEXT),
    handleLastPage: createPaginationPageHandler(PaginationAction.LAST),
  };

  return {
    handlers,
    createPaginationPageHandler,
  };
};
